import React from 'react';
import { Link } from 'react-router';
import { Notification } from '@ordermentum/ui-toast';
import {
  HideNotification,
  RemoveNotification,
  UINotification,
} from '@ordermentum/ui-definitions';

type Props = {
  notifications?: UINotification[];
  hideNotification: HideNotification;
  removeNotification: RemoveNotification;
};

export const Notifications = ({
  notifications,
  hideNotification,
  removeNotification,
}: Props) => {
  const handleHide = (id: string) => () => {
    hideNotification(id);
    setTimeout(() => {
      removeNotification(id);
    }, 150);
  };

  const notificationBlock = (n: UINotification) => (
    <Notification key={n.id} details={n} handleHide={handleHide(n.id)} />
  );

  if (!notifications) {
    return null;
  }

  const arr = notifications.map(n =>
    n.permalink ? (
      <Link
        key={n.id}
        to={n.permalink}
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className="om-notifications__link"
        activeClassName="om-notifications__sub-item-container--active"
      >
        {notificationBlock(n)}
      </Link>
    ) : (
      <div key={n.id}>{notificationBlock(n)}</div>
    )
  );

  return (
    <div className="fixed bottom-xl right-s z-[100] flex w-full flex-col items-end mobile:right-auto mobile:items-center">
      {arr}
    </div>
  );
};

export default Notifications;
